<template lang="pug">
  .height-100
    h3.title Mis Boletas
    p
    .view
      //- .filters
        p Mostrando boletas del periodo
        ul
          li.filtro(
            v-for="o in periodos"
            @click="filterPeriodo = o"
            :class="{ selected: o === filterPeriodo }"
          )
            span {{ o }}
      .filtros
        .filtro
          .title-singular
            p Selecciona un año
            .select
              select(v-model='filterPeriodo')
                option(:value="o", v-for="o in periodos") {{o}}
      .center(v-if="!isLoading")
        .article.message.is-info.margin-top-10(v-if="boletas.length === 0")
          section.message-body
            span No tiene boletas generadas
        .box(
          v-for="o in boletas"
          v-if="boletas.length > 0"
        )
          boleta-item-lista(
            :boleta="o"
            @ver="verPdf"
            @refresh="fetch"
          )
        transition(name="fade")
          .contenedor-frame(
            v-if="activateFrame"
            v-on-clickaway="cerrarFrame"
          )
            .titulo
              span.texto {{ tituloFrame }}
              .button(@click="cerrarFrame")
                span Cerrar
            iframe(
              :src="path"
            )
              | Oops! an error has occurred.
      .center(v-if="isLoading")
        loading

</template>

<script>
import BoletaItemLista from './Component_Boletas_Item_Lista'
import { apiGet, notify } from '../util/general'

export default {
  name: 'mis-boletas',
  components: {
    BoletaItemLista
  },
  data () {
    return {
      boletas       : [],
      activateFrame : false,
      path          : '',
      periodos      : [],
      filterPeriodo : '',
      tituloFrame   : '',
      isLoading     : true
    }
  },
  watch : {
    filterPeriodo (value) {
      this.fetch()
    }
  },
  created () {
    this.loadPeriodos()
  },
  methods: {
    loadPeriodos () {
      var vm = this
      var periodoInicial = 2018
      var periodoActual = +window.moment().format('YYYY')
      vm.filterPeriodo = periodoActual

      while (periodoActual >= periodoInicial) {
        vm.periodos.push(periodoActual)
        periodoActual--
      }
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        periodo: vm.filterPeriodo
      }
      apiGet(vm, '/boleta/empleado', obj, function (data) {
        vm.boletas = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    verPdf (boleta) {
      var vm = this
      // Obtener path enviando los datos
      vm.tituloFrame = 'Boleta de ' + boleta.nombreMes + ' ' + boleta.periodo + ' - ' + boleta.descripcionTipo
      vm.activateFrame = true
      var token = localStorage.getItem('token')
      // this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&codigo=' + boleta.codigo + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // Scroll top
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    cerrarFrame () {
      this.path = ''
      this.activateFrame = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .height-100
    height 100%
    min-height 100%
    position relative

  .view
    display flex
    flex-wrap: wrap;
    justify-content: center;

    .filters
      font-size: 16px;
      padding: 10px;

  .center
    flex 1
    display flex
    flex-direction column
    align-items center

  .box
    width: fit-content;

  .contenedor-frame
    position fixed
    background-color #ccc
    left 1
    top: 0px;
    left: 0px;
    width: 100%;
    height 100vh;
    padding 20px
    transition all 0.5s ease
    z-index: 9999

    .titulo
      display flex
      align-items center
      .texto
        flex 1
        text-align left
        font-size 25px
      .button
        margin-bottom 10px

    iframe
      width 100%
      height calc(100% - 30px);

  // .filtro
  //   cursor pointer
  //   &.selected
  //     font-weight bold
  //     color #3a4dc7
  .filtros
    margin-bottom 10px
    text-align left
    display flex
    align-items: flex-start;


    .filtro
      display inline-block
      border 1px solid #cccccc
      background-color #f9f9f9
      padding 5px
      margin 5px
      border-radius 3px
      flex 1
      .title-singular
        text-align left
        font-weight bold
        user-select: none
      .abierto-cerrado-container
        display flex
        .option
          padding 4px
          border 1px solid #565cde
          color #565cde
          cursor pointer
          transition all 0.3s ease
          height 31.5px

          &.selected
            background-color: #565cde;
            color: #fff;
    .select
      width: 100%
      select
        width 100%
</style>



// WEBPACK FOOTER //
// View_Mis_Boletas.vue?355b7eb0